import React from "react";
import { Card } from "react-bootstrap";
 
const VideoMaestro = () => {
    return (
        <>
            <Card>
                <Card.Header>Video di presentazione</Card.Header>
                <Card.Body>
                    <div className="m-5 text-center">Coming soon</div>
                </Card.Body>
            </Card>
        </>
    )
}
export default VideoMaestro;
